<template>
<div>
  <page-header :title="title"></page-header>
  <div class="error-container">
    <div class="well">
      <h1 class="grey lighter smaller"><span class="blue bigger-125"><i class="ace-icon fa fa-sitemap"></i> 404</span> Página não encontrada</h1>
      <hr/>
      <h3 class="lighter smaller">procuramos em todos lugares mas não encontramos esta página!</h3>
      <div>
        <div class="space"></div>
        <h4 class="smaller">Tente um dos seguintes procedimentos:</h4>
        <ul class="list-unstyled spaced inline bigger-110 margin-15">
          <li><i class="ace-icon fa fa-hand-o-right blue"></i>Verifique novamente o URL para erros de digitação</li>
          <li><i class="ace-icon fa fa-hand-o-right blue"></i>Conte-nos sobre isso</li>
        </ul>
      </div>
      <hr/>
      <div class="space"></div>
      <div class="center"><a class="btn btn-grey" href="javascript:history.back()"><i class="ace-icon fa fa-arrow-left"></i>Voltar</a>
        <router-link class="btn btn-primary" to="/"><i class="ace-icon fa fa-home"></i>Home</router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import PageHeader from '@/components/PageHeader'

export default {
	components: {
		PageHeader
	},
	data() {
		return {
			title: 'Erro 404'
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
